import { ActionType } from '@/actions';
import { ActionSetWeeksNumber } from './interfaces';

export const setWeeksNumber = (
  game: number,
  weeksNumber: number
): ActionSetWeeksNumber => {
  return {
    type: ActionType.WEEKS_NUMBER_SET,
    game,
    weeksNumber,
  };
};
